import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Cooperatives } from '../../components/mechanization/cooperatives';


const CooperativesPage: FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>Сельхоз кооперативы</title>
            </Helmet>
            <Cooperatives />

        </>
    );
};

export default CooperativesPage
